<template>
  <ChartTitleWrapper :title="title">
    <VueApexCharts type="line" :height="350" :options="chartOptions" :series="series" />
  </ChartTitleWrapper>
</template>

<script setup>
import { computed } from "vue";
import VueApexCharts from "vue3-apexcharts";

import { getChartOptions } from "@/app/reports/utils/chart";
import { Months } from "@/app/reports/utils/enums";

import ChartTitleWrapper from "@/app/reports/components/charts/ChartTitleWrapper.vue";

const props = defineProps({
  title: String,
  data: Array,
});

const currentMonth = new Date().getMonth();
const currMonthKey = Object.keys(Months)[currentMonth];
const prevMonthKey = Object.keys(Months)[currentMonth - 1];

const dataWithoutTotal = computed(() => props.data?.filter((row) => row?.tramo !== "Total") || []);
const categories = computed(() => dataWithoutTotal.value?.map((row) => row?.tramo));

const chartOptions = computed(() =>
  getChartOptions({
    xAxis: {
      title: "Horas",
      categories: categories.value,
    },
    yAxis: {
      title: "Número de llamadas",
    },
    chartColors: ["#B7EB8F", "#87E8DE"],
    legend: {
      show: true,
    },
    curve: "straight",
  })
);

const series = computed(() => [
  {
    name: Months[currMonthKey],
    data: dataWithoutTotal.value?.map((row) => row[currMonthKey]),
  },
  {
    name: Months[prevMonthKey],
    data: dataWithoutTotal.value?.map((row) => row[prevMonthKey]),
  },
]);
</script>

<style lang="sass" scoped>
h3
  font-size: 16px
  font-weight: 600
  margin: 35px 0 12px 0
  text-align: center
</style>
